<template>
  <a-card title="素材包管理">
    <a-form layout="inline" :model="formSearch" style="margin: 10px auto;" >
      <a-form-item>
        <a-input allowClear=true placeholder="名称" v-model:value="formSearch.name" />
      </a-form-item>
      <a-form-item  label="任务类型"  name="style_id">
        <a-select
          :allowClear="true"
          style="width: 230px;"
          v-model:value="formSearch.style_id"
          :options="TaskStyleGroupOptions"
        />
      </a-form-item>
       <a-form-item  label="素材类型"  name="resource_type">
        <a-select
          :allowClear="true"
          style="width: 100px;"
          v-model:value="formSearch.resource_type"
          :options="resourceTypeOptions"
        />
      </a-form-item>
      <a-form-item>
        <a-space>
          <a-button
            type="primary"
            html-type="submit"
            @click="handleTableChange()"
            shape="circle"
          >
          <template #icon><SearchOutlined /></template>
          </a-button>
          <a-button type="primary" @click="handleNewPackage()">新建素材包</a-button>
        </a-space>
      </a-form-item>
     
    </a-form>
  
    <a-alert :message="noticeMessage" type="info" show-icon style="text-align: left;"  />
      <a-table 
    class="ant-table-striped"
    show-quick-jumper
    :row-key="record => record.id"
    :data-source="dataSource" 
    :columns="columns" 
    :pagination="pagination"
    :loading="loading"
    @change="handleTableChange"
    :row-class-name="(_record, index) => (index % 2 === 1 ? 'table-striped' : null)"
    >
      <template #operator_id="{ record }">
        <Username :user_id="record.operator_id" />
      </template>
      <template #action="{ record }">
       <a-space>
        <a-button  @click="() => handleViewResources(record)">查看素材</a-button>
        <a-button danger @click="handleResourceUpload(record)">修改</a-button>

       </a-space>
      </template>
    </a-table>
  </a-card>

</template>
<script>
import { defineComponent,  h,onMounted} from 'vue'

import { SearchOutlined } from '@ant-design/icons-vue';
import request from '@/utils/request'
import { TaskStyleGroupOptions ,StyleNames} from '@/utils/macro'
import Username from '@/components/Username.vue';

export default defineComponent({
  components: {
    SearchOutlined,
    Username,
  },
  data(){
    return {
      loading: false,
      dataSource: [],
      pageNo: 0,
      StyleNames,
      TaskStyleGroupOptions,
      resourceTypeOptions: [
        {
          label: "Prompt", value: 'prompt'
        }, {
          label: "refer_image", value: 'refer_image'
        },
      ],
      pagination: {
        total: 1,
        current: 0,
        pageSize: 20,
        'show-quick-jumper': true,
        'show-size-changer': true,
        pageSizeOptions: ['20', '50', '100']
      },
      noticeMessage: '性能问题，总条数不再展示',
      formSearch: {
      style_id: '',
      name: '',
      resource_type: '',
    },

      uploadLoading: false,
    }
  },
  mounted(){
    this.handleTableChange()
  },
  computed:{
  },
  methods: {
    handleNewPackage(){
      this.$router.push({
        path: '/home/testcase/packages/resources/upload',
      })
    },

    handleResourceUpload(record){
      this.$router.push({
        path: '/home/testcase/packages/resources/upload',
        query: {
          package_id: record.id,
        }
      })
    },
    handleViewResources(record){
      this.$router.push({
        path: '/home/testcase/packages/resources',
        query: {
          package_id: record.id
        }
      })
    },
    async handleTableChange (pagi = {pageSize: 20, current: 1}) {
      this.loading = true
     
      let limit = pagi.pageSize
      let orderBy = "id desc"
      let offset =  (pagi.current - 1) * pagi.pageSize
      const rsp = await request.get('/api/testcase/packages/', {
        offset: offset,
        limit: limit,
        order_by: orderBy,
        ...this.formSearch,
        // after_cursor: afterCursor,
        // before_cursor: beforeCursor,
      })
      this.loading = false
      this.dataSource = [].concat(rsp.data.list)
      
      for(let item of this.dataSource) {
        item.created_at = new Date(item.created_at).toLocaleString()
        item.updated_at = new Date(item.updated_at).toLocaleString()
      }
      this.noticeMessage = `共 ${rsp.data.pagination.total} 条`

      this.pagination.total = rsp.data.pagination.total
      this.pagination.current = pagi.current
      this.pagination.pageSize = pagi.pageSize
    },
    
  },
  setup(props, context) {
   
    return {
      uploadInput: null,
      columns: [
      {
          title: 'ID',
          dataIndex: 'id',
          key: 'id',
          width:80,
        },
        {
          title: '名称',
          dataIndex: 'name',
          key: 'name',
          width:200,
        },
        {
          title: '描述',
          dataIndex: 'desc',
          key: 'desc',
        },
        {
          title: '类型',
          dataIndex: 'resource_type',
          key: 'resource_type',
        },
        {
          title: '素材数量',
          dataIndex: 'resource_count',
          key: 'resource_count',
        },
        {
          title: '创建时间',
          dataIndex: 'created_at',
          key: 'created_at',
          // slots: { customRender: 'created_at' },
        },
        {
          title: '操作人',
          dataIndex: 'operator',
          key: 'operator',
          slots: { customRender: 'operator_id' },
        },
         {
          title: '操作',
          dataIndex: 'action',
          key: 'action',
          slots: { customRender: 'action' },
        },
       
      ],
    };
  },
})
</script>

<style scoped>
</style>